<nav class="main-navbar">
  <div class="navbar-container">
    <div class="left">
      <a (click)="clickLogo()" class="logo">
        <img src="logo_tiny.png" alt="Objetos Personales Logo" />
      </a>
    </div>
    <div class="right">
      <ng-container *ngIf="isAdminPath()">
        <div class="nav-links">
          <a [class]="{ 'disabled': linkDisabled('/admin/dashboard') }" [routerLink]="'/admin/dashboard'">Dashboard</a>
          <!-- <a [class]="{ 'disabled': linkDisabled('/admin/tools') }" [routerLink]="'/admin/tools'">Tools</a> -->
          <a [class]="{ 'disabled': linkDisabled('/admin/bookstores') }" [routerLink]="'/admin/bookstores'">Librerias</a>
          <a [class]="{ 'disabled': linkDisabled('/admin/books') }" [routerLink]="'/admin/books'">Libros</a>
          <a [class]="{ 'disabled': linkDisabled('/admin/orders') }" [routerLink]="'/admin/orders'">Ordenes de compra</a>
          <a [class]="{ 'disabled': linkDisabled('/admin/comments') }" [routerLink]="'/admin/comments'">Comentarios</a>
          <a [class]="{ 'disabled': linkDisabled('/admin/files') }" [routerLink]="'/admin/files'">Archivos</a>
          <a (click)="logout()">logout</a>
        </div>
        <!-- <button (click)="changeLang()">change lang</button> -->
        <div class="responsive">
          <button mat-icon-button [matMenuTriggerFor]="mainMenuAdmin" aria-label="Menu Principal">
            <img height="20vw" width="20vw" src="burger-menu-svgrepo-com.svg" />
          </button>
          <mat-menu class="main-menu" #mainMenuAdmin="matMenu">
            <button mat-menu-item [disabled]="linkDisabled('/admin/dashboard')" [routerLink]="'/admin/dashboard'">
              <span>Dashboard</span>
            </button>
            <button mat-menu-item [disabled]="linkDisabled('/admin/bookstores')" [routerLink]="'/admin/bookstores'">
              <span>Librerias</span>
            </button>
            <button mat-menu-item [disabled]="linkDisabled('/admin/books')" [routerLink]="'/admin/books'">
              <span>Libros</span>
            </button>
            <!-- <button mat-menu-item [disabled]="linkDisabled('/admin/tools')" [routerLink]="'/admin/tools'">
              <span>Tools</span>
            </button> -->
            <button mat-menu-item [disabled]="linkDisabled('/admin/orders')" [routerLink]="'/admin/orders'">
              <span>Ordenes de compra</span>
            </button>
            <button mat-menu-item [disabled]="linkDisabled('/admin/comments')" [routerLink]="'/admin/comments'">
              <span>Comentarios</span>
            </button>
            <button mat-menu-item [disabled]="linkDisabled('/admin/files')" [routerLink]="'/admin/files'">
              <span>Archivos</span>
            </button>
            <button mat-menu-item (click)="logout()">
              <span>logout</span>
            </button>
          </mat-menu>
        </div>
      </ng-container>
      <ng-container *ngIf="!isAdminPath()">
        <div class="nav-links">
          <a [class]="{ 'disabled': linkDisabled('/catalogo') }" [routerLink]="'/catalogo'">Catálogo</a>
          <a [class]="{ 'disabled': linkDisabled('/autorxs') }" [routerLink]="'/autorxs'">Autorxs</a>
          <a [class]="{ 'disabled': linkDisabled('/prensa') }" [routerLink]="'/prensa'">Prensa</a>
          <a [class]="{ 'disabled': linkDisabled('/nosotrxs') }" [routerLink]="'/nosotrxs'">Nosotrxs</a>
          <a [class]="{ 'disabled': linkDisabled('/librerias') }" [routerLink]="'/librerias'">Librerías</a>
          <a [class]="{ 'disabled': linkDisabled('/extras') }" [routerLink]="'/extras'">Extras</a>
          <a [class]="{ 'disabled': linkDisabled('/contacto') }" [routerLink]="'/contacto'">Contacto</a>
        </div>
        <div class="responsive">
          <button mat-icon-button [matMenuTriggerFor]="mainMenu" aria-label="Menu Principal">
            <img height="20vw" width="20vw" src="burger-menu-svgrepo-com.svg" />
          </button>
          <mat-menu class="main-menu" #mainMenu="matMenu">
            <button mat-menu-item [disabled]="linkDisabled('/catalogo')" [routerLink]="'/catalogo'">
              <span>Catálogo</span>
            </button>
            <button mat-menu-item [disabled]="linkDisabled('/autorxs')" [routerLink]="'/autorxs'">
              <span>Autorxs</span>
            </button>
            <button mat-menu-item [disabled]="linkDisabled('/prensa')" [routerLink]="'/prensa'">
              <span>Prensa</span>
            </button>
            <button mat-menu-item [disabled]="linkDisabled('/nosotrxs')" [routerLink]="'/nosotrxs'">
              <span>Nosotrxs</span>
            </button>
            <button mat-menu-item [disabled]="linkDisabled('/librerias')" [routerLink]="'/librerias'">
              <span>Librerías</span>
            </button>
            <button mat-menu-item [disabled]="linkDisabled('/extras')" [routerLink]="'/extras'">
              <span>Extras</span>
            </button>
            <button mat-menu-item [disabled]="linkDisabled('/contacto')" [routerLink]="'/contacto'">
              <span>Contacto</span>
            </button>
          </mat-menu>
        </div>
        <app-carrito-popup></app-carrito-popup>
      </ng-container>
    </div>
  </div>
</nav>